<div class="modal-body">
  <p>{{ question | translate }}</p>
</div>
<div class="modal-footer">
  <button type="button" (click)="setOption('no')" class="btn btn--light" >{{ 'COMMON.NO' | translate }}</button>
  <button type="button" (click)="setOption('yes')" class="btn btn--submit" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')">{{ 'COMMON.YES' | translate }}</button>
</div>
